import Typography from '@ixigo/iui/Typography';
import format from 'date-fns-tz/format';
import isSameDay from 'date-fns/isSameDay';
import parseISO from 'date-fns/parseISO';
import sub from 'date-fns/sub';
import { DayProps } from './index.types';

function Day({ date, lastDate }: DayProps) {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    let parsedLastDate;

    if (!lastDate) parsedLastDate = parsedDate;
    else parsedLastDate = typeof lastDate === 'string' ? parseISO(lastDate) : lastDate;

    if (lastDate && isSameDay(parsedDate, parsedLastDate)) return null;

    const getFormattedDate = () => {
        const today = new Date();

        if (isSameDay(parsedDate, today)) return 'Today';
        if (isSameDay(parsedDate, sub(today, { days: 1 }))) return 'Yesterday';
        return format(parsedDate, 'E, d MMM');
    };

    return (
        <Typography variant='body-sm' fontWeight='medium' className='mb-5 text-center mt-30 text-charcoal-600'>
            {getFormattedDate()}
        </Typography>
    );
}

export default Day;
